// src/config/api.js
const API_BASE_URL = "http://localhost:8000";  // 개발 중에는 로컬 서버 주소, 나중에 배포 시 변경 예정

export default API_BASE_URL;